import { NodeModel } from '@projectstorm/react-diagrams';
import { BaseModelOptions } from '@projectstorm/react-canvas-core';

export interface DefaultNodeModelOptions extends BaseModelOptions {
	color?: string;
	title?: string;
}

export default class DefaultNodeModel extends NodeModel {
    data: any;

    title: string = '';

    color: string = '';

    constructor(options: DefaultNodeModelOptions = {}) {
      super({
        ...options,
      });
      this.color = options.color || 'red';
      this.title = options.title || '';
    }

    serialize() {
      return {
        ...super.serialize(),
        data: this.data,
        title: this.title,
        color: this.color,
      };
    }

    deserialize(event:any): void {
      super.deserialize(event);
      this.data = event.data.data;
      this.title = event.data.title;
      this.color = event.data.color;
    }
}
